import { forwardRef, type CSSProperties, type HTMLAttributes } from 'react';

const hidden: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

export type VisuallyHiddenProps = HTMLAttributes<HTMLSpanElement>;

/* Text for assistive tech only (live-region copy, the name part a visual badge cannot carry). */
export const VisuallyHidden = forwardRef<HTMLSpanElement, VisuallyHiddenProps>(function VisuallyHidden(
  { style, ...rest },
  ref,
) {
  return <span ref={ref} data-rv-visually-hidden="" style={{ ...hidden, ...style }} {...rest} />;
});
